<template>
    <div>
        <!-- We need the stylesheet from <v-bottom-sheet>, but the actual component has a bug causing scroll not to work
                so the following row is required until the <div> can be replaced with a <v-bottom-sheet>
                See: https://github.com/vuetifyjs/vuetify/issues/6495
            -->
        <v-bottom-sheet />

        <div style="height: 104px" v-if="showCartInfoBar"> <!-- To make it possible to scroll down -->
        </div>

        <transition name="bottom-sheet-transition">
            <div tabindex="-1" class="v-dialog__content v-dialog__content--active" style="z-index: 202; height:auto" v-if="showCartInfoBar" :style="{bottom: $vuetify.breakpoint.mobile ? '56px' : '0px'}" @click="cart.showCheckout = true">
                <div class="v-dialog v-bottom-sheet v-dialog--active v-dialog--persistent" style="max-width: 600px">
                    <div>
                        <v-sheet class="d-flex flex-row" color="primarytext">
                            <v-icon color="primary" large class="ml-2">mdi-cart-outline</v-icon>

                            <div class="ma-4 font-weight-bold">
                                <v-scale-transition leave-absolute>
                                    <div :key="'cartText' + cartText" v-text="cartText" />
                                    <!-- <div :key="`count-${productCount}`">{{productCount}} {{productCount == 1 ? 'artikel' : 'artiklar'}}</div> -->
                                </v-scale-transition>
                                <div>
                                    <span v-if="cartPriceFromServer.discount" class="zoezi-original-price text--secondary">{{cartFullPriceString}}</span>
                                    {{cartPriceString}}
                                </div>
                            </div>
                            <v-spacer />

                            <v-btn class="ma-4 zoezi-button-thin" color="primary" @click.stop="cart.showCheckout = true">{{$translate('Go to Checkout')}}</v-btn>
                        </v-sheet>
                    </div>
                </div>
            </div>
        </transition>

        <bottom-dialog v-model="cart.showCheckout" scrollable max-width="850px" :dialog="!$vuetify.breakpoint.mobile" v-if="cart && cart.showCheckout && !$store.state.checkoutHidden">
            <v-card class="zoezi-bottom-sheet" tile elevation="0">
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        {{$translate('Complete the purchase')}}
                        <v-btn icon @click="cart.showCheckout = false" class="float-right" v-if="!checkoutLoading"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>

                <v-card-text :class="{'px-2': $vuetify.breakpoint.mobile }" class="z-no-x-scroll pb-0" style="min-height: 50vh">
                    <checkout
                        ref="checkout"
                        :useCart="true"
                        :cartName="cartName"
                        class="overflow-y-auto"
                        :items="[]"
                        :expand-first-item="false"
                        :show-summary="true"
                        :show-back-link="false"
                        :show-payment-button="false"
                        :new-style-done-dialog="true"
                        @done="clearCart();"
                        @loading="checkoutLoading = $event"
                        @changeNumberOfItems="changeNumberOfItems"
                        @changeItemUsers="changeItemUsers"
                        @changeIncludedProductVariant="changeIncludedProductVariant"
                        @readyToPay="readyToPay = $event"
                        @cost="cost = $event"
                        @mustSelectUsers="mustSelectUsers = $event"
                        @paymentMethod="paymentMethod = $event"
                        :site-id="cart.site_id"
                        content-target="checkoutcontent"
                        :dialog="true"
                    >
                        <template #content>
                            <stepper-content v-model="currentStep" :steps="steps">
                                <template #checkout>
                                    <portal-target name="checkoutcontent" />
                                </template>
                                <template #membership>
                                    <membership-checkout
                                        :items="checkoutItems"
                                        :cart-name="cartName" />
                                </template>
                            </stepper-content>
                        </template>
                    </checkout>
                </v-card-text>
                <v-card-actions>
                    <stepper v-model="currentStep" :steps="steps" @cancel="cart.showCheckout = false" ref="stepper"  :disabled="checkoutLoading" :show-title="steps.length > 1" />
                </v-card-actions>
            </v-card>
        </bottom-dialog>
    </div>
</template>

<script>
import { formatPrice, decodeJson2 } from '../util';
import BottomDialog from '../components/BottomDialog.vue'
import Checkout from './Checkout.vue'
import Stepper from '../views/Stepper.vue'
import StepperContent from '../views/StepperContent.vue'
import MembershipCheckout from '../views/MembershipCheckout.vue'
export default {
    name: 'zoezi-shopping-cart',

    watch: {
        checkoutItems: {
            immediate: true,
            handler(newValue, oldValue) {
                // This is to detect when all items have been removed from cart and checkout should be hidden. Is tere a better way?
                if (oldValue && oldValue.length && this.cart && this.cart.showCheckout && (!newValue || newValue.length == 0)) {
                    this.cart.showCheckout = false;
                    this.cart.showBottomBar = false;
                }
                if (newValue && newValue.length) {
                    this.fetchCartPrice(newValue);
                }
            }
        },
        membershipStillRequired: {
            immediate: true,
            handler(membershipStillRequired) {
                if (membershipStillRequired) {
                    this.currentStep = 0;
                } else {
                    if (this.$booking.isMembershipRequired(this.checkoutItems)) {
                        this.currentStep = 1;
                    } else {
                        this.currentStep = 0;
                    }
                }
            }
        }
    },

    computed: {
        products() {
            return this.$store.getters.allProducts;
        },
        cartName() {
            if (!this.$store.state.carts) {
                return null;
            }
            return Object.keys(this.$store.state.carts).find(cartName => {
                let cart = this.$store.state.carts[cartName];
                return cart.showBottomBar || cart.showCheckout;
            });
        },
        cart() {
            if (!this.products || this.products.length == 0 || this.cartName === null) {
                return null;
            }

            return this.$store.state.carts[this.cartName];
        },
        checkoutItems() {
            if (!this.cart) {
                return [];
            }
            return this.cart.items.map(x => {
                let item = {};
                Object.assign(item, x);
                item.product = this.products.find(p => p.id == x.product_id);
                return item;
            });
        },
        productCount() {
            let count = 0;
            this.checkoutItems.forEach(i => count += (i.count || 1));
            return count;
        },
        cartPriceString() {
            return formatPrice(this.cartPriceFromServer.total);
        },
        cartFullPriceString() {
            return formatPrice(this.cartPriceFromServer.full_amount);
        },
        showCartInfoBar() {
            return !this.$root.edit && this.checkoutItems.length > 0 && this.cartPriceFromServer && this.cart && this.cart.showBottomBar && !this.cart.showCheckout && !this.$store.state.checkoutHidden;
        },
        cartText() {
            if (this.checkoutItems.length == 1) {
                let item = this.checkoutItems[0];
                const pcs = this.$translate('pcs');
                const article = this.$translate('article');
                let itemName = item.product ? item.product.name : (item.service ? item.service.name : article);
                return item.count == 1 ? itemName : `${item.count} ${pcs} ${itemName}`;
            }

            return this.productCount == 1 ? `1 ${this.$translate('article')}` : `${this.productCount} ${this.$translate('articles')}`;
        },
        membershipStillRequired() {
            return this.$booking.isMembershipStillRequired(this.checkoutItems);
        },
        steps() {
            let nextTitle = this.cost > 0 ? `${this.$translate('Pay')} ${formatPrice(this.cost)}` : this.$translate('Confirm Purchase');
            if (!this.$store.state.user) {
                nextTitle = this.$translate('Identify yourself');
            } else if (this.mustSelectUsers) {
                nextTitle = this.$translate('Who will receive the product?');
            } else if (this.paymentMethod == 'unknown' || this.paymentMethod == 'invoice' || this.paymentMethod == 'directdebit') {
                nextTitle = `${this.$translate('Confirm purchase')} ${formatPrice(this.cost)}`;
            } else if (!this.paymentMethod && this.cost > 0) {
                nextTitle = this.$translate('Choose payment method');
            }

            let steps = [];
            if (this.$booking.isMembershipRequired(this.checkoutItems)) {
                let mcomplete = !this.$booking.isMembershipStillRequired(this.checkoutItems);
                steps.push({title: this.$translate('Membership'), id: 'membership', complete: mcomplete, nextTitle: this.$translate(mcomplete ? 'Continue' : 'Choose membership')});
            }

            let extraButton = {label: this.$translate('Continue shopping'), clicked: () => this.cart.showCheckout = false, disabled: false };
            steps.push({title: this.$translate('Complete'), id: 'checkout', nextTitle, nextColor: '#7bbd1b', nextDark: true, nextClicked: this.pay, nextLoading: this.checkoutLoading, complete: this.readyToPay, extraButton });
            return steps;
        }
    },

    components: {
        BottomDialog,
        Checkout,
        Stepper,
        StepperContent,
        MembershipCheckout
    },

    data: () => ({
        checkoutLoading: false,
        readyToPay: false,
        cost: 0,
        currentStep: 0,
        mustSelectUsers: false,
        paymentMethod: null,
        cartPriceFromServer: null
    }),

    methods: {
        clearCart() {
            this.$store.dispatch('removeCart', {cartName: this.cartName})
        },
        changeNumberOfItems(item, count) {
            this.$store.dispatch('changeItemCountInCart', {cartName: this.cartName, product_id: item.product_id, variant: item.variant, count, tmp_id: item.tmp_id});
        },
        changeItemUsers(item, users) {
            this.$store.dispatch('changeItemUsersInCart', {cartName: this.cartName, product_id: item.product_id, variant: item.variant, users});
        },
        changeIncludedProductVariant(item, index, includedProductId, value) {
            this.$store.dispatch('changeItemIncludedProductVariantsInCart', {cartName: this.cartName, product_id: item.product_id, variant: item.variant, index, includedProductId, value});
        },
        fetchCartPrice(items) {
            this.$api.post('/api/public/webshop/total', {items}).then(r => {
                if (!r.ok) {
                    r.json().then(response => {
                        let text = this.$translate(response.message);
                        this.$store.commit('showSnackBar', {text});
                    });
                } else {
                    r.json().then(x => {
                        this.cartPriceFromServer = decodeJson2(x);
                    });
                }
            });
        },
        pay() {
            this.$refs.checkout.completePurchase();
        }
    },

    mounted() {
        this.$store.dispatch('loadProducts');
    }
}
</script>
